import moment from 'moment'
export function isMobile() {
  let flag = navigator.userAgent.match(
    /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
  );
  return flag;
}

export function getRandom(min, max) {
  // 以下函数返回 min（包含）～ max（包含）之间的数字：
  return Math.floor(Math.random() * (max - min + 1)) + min;

  //  函数返回 min（包含）～ max（不包含）之间的数字
  //  this.data = Math.floor(Math.random() * (max - min) ) + min;
}

/**
 *
 * @param {*要分组的集合} array
 * @param {*分组项名称} groupItem
 */
export function ArrayGroup(array, groupItem) {
  const groups = {}
  array.forEach(function(item) {
    const group = item[groupItem]
    // 这里利用对象的key值唯一性的，创建数组
    groups[group] = groups[group] || []
    groups[group].push(item)
  })
  // 最后再利用map循环处理分组出来
  return Object.keys(groups).map(function(group) {
    var newobj = {}
    newobj.key = group
    newobj.value = groups[group]
    return newobj
  })
}
export function GetAgeText(dtBirthday, limitAge) {
  var dtNow = new Date()// 当前时间
  var strAge = ''// 年龄的字符串表示
  var intYear = 0 // 岁
  var intMonth = 0 // 月
  var intDay = 0 // 天
  // 计算天数
  intDay = dtNow.getDate() - new Date(moment(dtBirthday)).getDate()
  if (intDay < 0) {
    const date = new Date(moment(dtNow).subtract(1, 'months').format('YYYY-MM-DD'))
    dtNow = date
    intDay += getMonthDays(dtNow.getFullYear(), dtNow.getMonth()) + 1
  }
  // 计算月数
  intMonth = dtNow.getMonth() - new Date(moment(dtBirthday)).getMonth()
  if (intMonth < 0) {
    intMonth += 12
    const date = new Date(moment(dtNow).subtract(1, 'years').format('YYYY-MM-DD'))
    dtNow = date
  }
  // 计算年数
  intYear = dtNow.getFullYear() - new Date(moment(dtBirthday)).getFullYear()
  // 格式化年龄输出
  if (intYear >= 1) { // 年份输出
    strAge = intYear + '岁'
  }
  if (intMonth > 0 && intYear < limitAge) {
    strAge += intMonth + '月'
  }

  if (intDay >= 0 && intYear < 1) {
    if (strAge.Length === 0 || intDay > 0) {
      strAge += intDay + '天'
    }
  }
  return strAge
}
// 获取某月天数
function getMonthDays(myYear, myMonth) {
  var year = parseInt(myYear)
  var month = parseInt(myMonth)
  var monthStartDate = moment(year + '/' + month + '/1')

  // 12月份的下个月是下一年1月1号
  if (month === 12) {
    year++
    month = 1
  }

  var monthEndDate = moment(year + '/' + (month + 1) + '/1')
  var days = (monthEndDate - monthStartDate) / (1000 * 60 * 60 * 24)
  return days
}
export function GetSexText(cellValue) {
  var ret = cellValue
  if (cellValue === 0) {
    ret = '未知'
  }
  if (cellValue === 1) {
    ret = '男'
  }
  if (cellValue === 2) {
    ret = '女'
  }
  return ret
}